import FromFigma from "../../assets/img/meta.json";

const preloadAssets = FromFigma.filter(asset => asset.src.includes("preloader"));
const mainAssets = FromFigma.filter(asset => asset.src.includes("main"));

export const manifest = {
    fonts: {
        custom: {

        },
    },
    bundles: [
        {
            name: "Fonts",
            assets: [
                { alias: "Nunito", src: "./assets/font/Nunito-Black.ttf", data: {family: 'Nunito'} },
            ],
        },
        {
            name: "logo",
            assets: [
                { alias: "config", src: "./assets/config.json" },
                { alias: "components.config", src: "./assets/components.config.json" },
                { alias: "LogoAnimationData", src: "./assets/spine/basta_play.json" },
                { alias: "LogoAnimationAtlas", src: "./assets/spine/basta_play.atlas" },
                { alias: "Loading_Common", src: "./assets/spritesheet/Loading_Common.json" },
            ],
        },
        {
            name: "preloader",
            assets: [...preloadAssets],
        },
        {
            name: "sounds",
            assets: [
                { alias: "basegame_loop", src: "./assets/sound/basegame_loop.ogg" },
                { alias: "bg_music_1", src: "./assets/sound/bg_music_1.ogg" },
                { alias: "bomb_symbol_highlight", src: "./assets/sound/bomb_symbol_highlight.ogg" },
                { alias: "button_click", src: "./assets/sound/button_click.ogg" },
                { alias: "button_hover", src: "./assets/sound/button_hover.ogg" },
                { alias: "counter_loop", src: "./assets/sound/counter_loop.ogg" },
                { alias: "free_spins_pays_counter_loop", src: "./assets/sound/free_spins_pays_counter_loop.ogg" },
                { alias: "freegame_loop", src: "./assets/sound/freegame_loop.ogg" },
                { alias: "freespin_transition", src: "./assets/sound/freespin_transition.ogg" },
                { alias: "fs_trigger", src: "./assets/sound/fs_trigger.ogg" },
                { alias: "multiplier_merge_anim", src: "./assets/sound/multiplier_merge_anim.ogg" },
                { alias: "multiplier_split_anim", src: "./assets/sound/multiplier_split_anim.ogg" },
                { alias: "reel_stop", src: "./assets/sound/reel_stop.ogg" },
                { alias: "reel_stop_excited_win_1", src: "./assets/sound/reel_stop_excited_win_1.ogg" },
                { alias: "reel_stop_excited_win_2", src: "./assets/sound/reel_stop_excited_win_2.ogg" },
                { alias: "reel_stop_excited_win_3", src: "./assets/sound/reel_stop_excited_win_3.ogg" },
                { alias: "scatter_1", src: "./assets/sound/scatter_1.ogg" },
                { alias: "scatter_2", src: "./assets/sound/scatter_2.ogg" },
                { alias: "scatter_3", src: "./assets/sound/scatter_3.ogg" },
                { alias: "scatter_4", src: "./assets/sound/scatter_4.ogg" },
                { alias: "scatter_5", src: "./assets/sound/scatter_5.ogg" },
                { alias: "spin_button_click", src: "./assets/sound/spin_button_click.ogg" },
                { alias: "symbol_tumble_0", src: "./assets/sound/symbol_tumble_0.ogg" },
                { alias: "symbol_tumble_1", src: "./assets/sound/symbol_tumble_1.ogg" },
                { alias: "symbol_tumble_2", src: "./assets/sound/symbol_tumble_2.ogg" },
                { alias: "symbol_vanish_0", src: "./assets/sound/symbol_vanish_0.ogg" },
                { alias: "symbol_vanish_1", src: "./assets/sound/symbol_vanish_1.ogg" },
                { alias: "symbol_vanish_2", src: "./assets/sound/symbol_vanish_2.ogg" },
                { alias: "symbol_vanish_3", src: "./assets/sound/symbol_vanish_3.ogg" },
                { alias: "symbol_vanish_4", src: "./assets/sound/symbol_vanish_4.ogg" },
                { alias: "symbol_vanish_5", src: "./assets/sound/symbol_vanish_5.ogg" },
                { alias: "symbol_vanish_6", src: "./assets/sound/symbol_vanish_6.ogg" },
                { alias: "symbol_vanish_7", src: "./assets/sound/symbol_vanish_7.ogg" },
                { alias: "symbol_vanish_8", src: "./assets/sound/symbol_vanish_8.ogg" },
                { alias: "symbol_vanish_9", src: "./assets/sound/symbol_vanish_9.ogg" },
                { alias: "symbol_vanish_effect", src: "./assets/sound/symbol_vanish_effect.ogg" },
                { alias: "symbol_win_general", src: "./assets/sound/symbol_win_general.ogg" },
            ],
        },
        {
            name: "main",
            assets: [
                ...mainAssets,

                { alias: "freeSpinIntroData", src: "./assets/spine/fs_intro/win_free_spin.json" },
                { alias: "freeSpinIntroAtlas", src: "./assets/spine/fs_intro/spine.atlas" },

                { alias: "freeSpinOutroAtlas", src: "./assets/spine/fs_outro/spine.atlas" },
                { alias: "freeSpinOutroData", src: "./assets/spine/fs_outro/win_free_spin.json" },

                { alias: "BackgroundBonusAnimationData", src: "./assets/spine/bg_bonus/bg.json" },
                { alias: "BackgroundBonusAnimationAtlas", src: "./assets/spine/bg_bonus/bg.atlas" },

                { alias: "gool_hv_1Data", src: "./assets/spine/gool_hv_1/gool_hv_1.json" },
                { alias: "gool_hv_1Atlas", src: "./assets/spine/gool_hv_1/gool_hv_1.atlas.txt" },

                { alias: "BackgroundAnimationData", src: "./assets/spine/background/bg.json" },
                { alias: "BackgroundAnimationAtlas", src: "./assets/spine/background/bg.atlas" },


                { alias: "TransitionAnimationData", src: "./assets/spine/transition.json" },
                { alias: "TransitionAnimationAtlas", src: "./assets/spine/transition.atlas" },

                { alias: "WinsAnimationData", src: "./assets/spine/wins/win.json" },
                { alias: "WinsAnimationAtlas", src: "./assets/spine/wins/win.atlas" },

                { alias: "EffectSymbolsAnimationAtlas", src: "./assets/spine/symbols/effect_symbols.atlas" },

                { alias: "AppleSymbolData", src: "./assets/spine/symbols/apple.json" },
                { alias: "BananaSymbolData", src: "./assets/spine/symbols/banana.json" },
                { alias: "BigCandySymbolData", src: "./assets/spine/symbols/big_candy.json" },
                { alias: "BlueCandySymbolData", src: "./assets/spine/symbols/blue_candy.json" },
                { alias: "BombEffectSymbolData", src: "./assets/spine/symbols/bomb_effect.json" },
                { alias: "BombFuseSymbolData", src: "./assets/spine/symbols/bomb_fuse.json" },
                { alias: "BombLargeSymbolData", src: "./assets/spine/symbols/bomb_large.json" },
                { alias: "CandyGreenSymbolData", src: "./assets/spine/symbols/candy_green.json" },
                { alias: "CandyVioletSymbolData", src: "./assets/spine/symbols/candy_violet.json" },
                { alias: "EffectSymbolData", src: "./assets/spine/symbols/effect.json" },
                { alias: "GrapeSymbolData", src: "./assets/spine/symbols/grape.json" },
                { alias: "HeartSymbolData", src: "./assets/spine/symbols/heart.json" },
                { alias: "PlumSymbolData", src: "./assets/spine/symbols/plum.json" },
                { alias: "WatermelonSymbolData", src: "./assets/spine/symbols/watermelon.json" },
            ],
        },
    ],
};
